import { schemaEntityWithIdAndDescription } from "src/types";
import { z } from "zod";
import { EntidadCacheFields } from "../sistemas/adcm/types/fields";

export const schemaEntidadCache = z.object({
  [EntidadCacheFields.CodVirtual]: z.number()
}).merge(schemaEntityWithIdAndDescription);

export type EntidadCache = z.infer<typeof schemaEntidadCache>;


export const schemaStringObligatorio = z
  .string()
  .trim()
  .min(1, 'Campo requerido')
  .max(250, 'Máximo 250 caracteres');


export const schemaStringOpcional = z.preprocess(
  (val) => (val === '' ? undefined : val),
  z.string().max(250, 'Máximo 250 caracteres').optional().nullable()
);